import React, {
  createContext,
  useCallback,
  useContext,
  useMemo,
  useState,
} from 'react';

const DEFAULT_TITLE = 'Untitled Course';

type AiCoursewareHeaderContextValue = {
  title: string;
  setHeaderTitle: (title: string) => void;
};

const AiCoursewareHeaderContext =
  createContext<AiCoursewareHeaderContextValue | null>(null);

export function AiCoursewareHeaderProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const [title, setTitle] = useState(DEFAULT_TITLE);

  const setHeaderTitle = useCallback((next: string) => {
    const t = next.trim();
    setTitle(t || DEFAULT_TITLE);
  }, []);

  const value = useMemo(
    () => ({ title, setHeaderTitle }),
    [title, setHeaderTitle]
  );

  return (
    <AiCoursewareHeaderContext.Provider value={value}>
      {children}
    </AiCoursewareHeaderContext.Provider>
  );
}

export function useAiCoursewareHeader() {
  const ctx = useContext(AiCoursewareHeaderContext);
  if (!ctx) {
    throw new Error(
      'useAiCoursewareHeader must be used within AiCoursewareHeaderProvider'
    );
  }
  return ctx;
}
